module.exports = __webpack_public_path__ + "images/sd-04-faq-desktop.png";